import { Col, Input, Row } from 'antd'
import { HelpMessage } from 'utils/constants'
import CIMSFormItem from 'components/CIMSFormItem'
import GroupSelect from '../../../../GroupSelect'
import EditGoogleSheetBody from './EditGoogleSheetBody'
import { EditBodyProps } from './types'
import { useConnectionsContext } from '../../../ConnectionsContext'
import EditHeadersFormList from '../../../../../../EditHeadersFormList'
import CIMSDivider from 'components/CIMSDivider'

const EditBody: React.FC<EditBodyProps> = ({ googleSheet, headers }) => {
  const { groups, fetching } = useConnectionsContext()
  return (
    <>
      <Row gutter={8}>
        <Col md={12} sm={1}>
          <CIMSFormItem label="Name" name="name" help={HelpMessage.Name}>
            <Input allowClear />
          </CIMSFormItem>
        </Col>
        <Col md={12} sm={1}>
          <GroupSelect options={groups} loading={fetching} />
        </Col>
      </Row>
      {googleSheet && <EditGoogleSheetBody />}
      <CIMSDivider help={HelpMessage.PayItems.Summary.GoogleSheet.Headers}>
        Headers
      </CIMSDivider>
      <EditHeadersFormList headers={headers} />
    </>
  )
}

export default EditBody
